import { Textarea, TextareaInput } from "@/components/ui/textarea";
import { VStack } from "@/components/ui/vstack";
import { Text } from "@/components/ui/text";
import { Input, InputField } from "@/components/ui/input";
import React, { useEffect, useState } from 'react'
import { ModalWrapper } from "./ModalWrapper";

import AvatarEdit from '../../../../components/media/AvatarEdit';

import { useSelector, useDispatch } from "react-redux";
import { requestModal } from '../../../../stores/mainSlice';
import { useNavigation } from "@react-navigation/native";
import { switchScreen } from '../../../../hooks/navigate';

import i18n from "i18n-js";
import * as assets_images from '../../../../assets/images';

export const ChannelPreference = (modal) => {
  const dispatch = useDispatch();
  const navigation = useNavigation();

  const isWaiting = modal.option?.request?.isWaiting ?? false;
  const isAcknowledged = modal.option?.request?.isAcknowledged ?? false;
  const hasIssues = modal.option?.request?.issues ?? {};

  const channel = useSelector((state) => state.contacts.channels) //
    .filter(_ => _.id === modal.option?.channel?.id)[0] ?? {};

  const [inputdChannelImage, onInputdChannelImage] = useState();
  const [inputdChannelName, onInputdChannelName] = useState();
  const [inputdChannelDescription, onInputdChannelDescription] = useState();

  if (isAcknowledged) {
    modal.onClose();
  }

  const all_workflows_lookup = useSelector((state) => state.workflows);

  useEffect(() => {
    if (modal.opened === undefined) {
      onInputdChannelImage(undefined);
      onInputdChannelName('');
      onInputdChannelDescription('');
    }
  }, [modal.opened]);

  useEffect(() => {
    if (channel?.id) {
      // ? restore values for update
      onInputdChannelImage(channel?.channelImage?.id ?? undefined);
      onInputdChannelName(channel?.name ?? '');
      onInputdChannelDescription(channel?.description ?? '');
    }
  }, [channel]);

  const onBack = () => {
    modal.onClose();
  }

  const onSubmit = () => {
    submitInputs({
      channel: {
        ...channel,

        channelImage: inputdChannelImage && (inputdChannelImage != channel?.channelImage?.id)
          ? { blob_uri: inputdChannelImage }
          : { id: channel?.channelImage?.id },

        name: inputdChannelName,
        description: inputdChannelDescription,
      }
    });
  }

  const submitInputs = ({ channel }) => {
    const issues = {}, request = {
      isWaiting: false,
      isAcknowledged: false,
      issues: null
    };

    // ? values
    const channel_name = channel.name.trim();
    const channel_description = channel.description.trim();


    // ? validation
    if (!channel_name || channel_name.length <= 2) {
      issues['channel.name'] = 'err:missingName';
    }
    // FIXME(@Milo): limit input lengths?
    // else if (channel_name.length > 200) {
    //   issues['channel.name'] = 'err:lengthLimitName';
    // }
    // if (!!channel_description || channel_description.length > 2000) {
    //   issues['channel.description'] = 'err:lengthLimitDescription';
    // }

    if (Object.keys(issues).length) {
      request.issues = issues;

      modal.onUpdate({ request });
      return;
    };

    console.debug('[Modal]', 'submit', { request })

    // ? request
    request.isWaiting = true;

    const request_path = channel.id ? '/contact/channel/' + channel.id : '/contact/channel';
    const request_method = channel.id ? 'PUT' : 'POST';

    modal.onUpdate({ request });
    modal.onRequest('UPDATE_CHANNEL_INLINE', request_path, {
      name: channel_name,
      description: channel_description,
      contacts: channel.contacts,
      workflows: channel.workflows?.map((local_workflow_id) => (all_workflows_lookup[local_workflow_id].workflowId))
    }, request_method).then((data) => {
      // ---
      console.debug('[Modal]', 'onRequest.then', !!data.result, data?.result)
      // ---

      if (data.result && channel.channelImage?.blob_uri) {
        const upload_request_path = '/contact/channel/' + data.result.id + '/image';

        modal.onUploadImageAsyncRequest('UPDATE_IMAGE_INLINE', upload_request_path, {
          uri: channel.channelImage.blob_uri,
          description: channel_name
        }).then((image_data) => {
          // ---
          console.debug('[Modal]', 'onUploadImageAsyncRequest.then', !!image_data.result, image_data.result)
          // ---

          // FIXME(@Milo): Show toast if image upload failed.
        });
      }

      if (data.result) {
        // will not wait for image

        modal.onUpdate({
          request: {
            isAcknowledged: true,  // signal modal can close
            isWaiting: true, // keep locked
            issues: null,
          }
        });

        if (!channel.id) {
          switchScreen(navigation, 'ViewChannel', { k: data.result.id });
          setTimeout(() => {
            dispatch(requestModal({
              type: 'channel:update-members',
              option: {
                channel: { id: data.result.id },
              }
            }));
          }, 600)
        }
      } else {
        modal.onUpdate({
          request: {
            isAcknowledged: false,  // signal can close
            isWaiting: false,
            issues: {
              'request-failed': '*' // User ID unknown
            },
          }
        });
      }

    })
  }

  // const [image, setImage] = useState(channel?.channelImage?.id)

  const channel_image = inputdChannelImage ?? assets_images.placeholderImg;

  return (
    <ModalWrapper
      onClose={modal.onClose}
      onBack={onBack}
      onSubmit={onSubmit}

      isVisible={modal.isVisible}
      isWaiting={isWaiting}
      title={channel?.id ? i18n.t('channel.update') : i18n.t('channel.create')}
      buttonBack={{ text: i18n.t('addContact.cancel') }}
      buttonSubmit={{ text: channel?.id ? i18n.t('channel.continue') : i18n.t('channel.submit') }}
    >
      <Text className="text-md text-secondary-600">{i18n.t('channel.noChannels')}</Text>
      <VStack>
        <AvatarEdit
          key={channel_image} uri={channel_image}
          selected={onInputdChannelImage} sync={'/contact/media/' + channel_image}
          // isDisabled={isWaiting || !modal.isVisible}
          isEdit={!(isWaiting || !modal.isVisible)}
        />
      </VStack>
      <VStack>
        <Input
          variant="outline" size="md"
          isDisabled={isWaiting || !modal.isVisible}
          isInvalid={'channel.name' in hasIssues}
          isReadOnly={false}
        >
          <InputField
            defaultValue={inputdChannelName}
            onChangeText={onInputdChannelName}
            placeholder={i18n.t('channel.name')}
          />
        </Input>
        {'channel.name' in hasIssues && (
          <Text className="mt-2 text-xs text-error-600">{i18n.t('channel.missing')}</Text>
        )}
      </VStack>
      <VStack>
        <Textarea
          variant="outline" size="md"
          isDisabled={isWaiting || !modal.isVisible}
          isInvalid={'channel.description' in hasIssues}
          isReadOnly={false}
        >
          <TextareaInput
            defaultValue={inputdChannelDescription}
            onChangeText={onInputdChannelDescription}
            placeholder={i18n.t('channel.description')}
          />
        </Textarea>
        {'channel.description' in hasIssues && (
          (<></>)
          // FIXME(@Milo): add i18n for `channel.description` issues
          // <Text mt='$2' fontSize='$xs' color='$error600'>{i18n.t('channel.description.missing')}</Text>
        )}
      </VStack>
      <VStack>
        {'request-failed' in hasIssues && (
          <Text className="mt-2 text-xs text-error-600">{hasIssues['request-failed']}</Text>
        )}
      </VStack>
    </ModalWrapper>
  );
}
